// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"1c8d275f","636":"9d9c8a31","828":"049969b8"}[chunkId] + ".chunk.js";
};